// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ISlOXhkxs4Th6ZaYXjBW{grid-column:1/-1;margin-bottom:50px}@media(max-width: 767px){.ISlOXhkxs4Th6ZaYXjBW{margin-bottom:28px}}.ISlOXhkxs4Th6ZaYXjBW>*{margin-bottom:20px}.ISlOXhkxs4Th6ZaYXjBW>*:last-child{margin-bottom:0}.THRSgafRXuhbc9r0u8aO,.b5CbZWM8BUBnnkomiHsD{grid-column:1/-1}.b5CbZWM8BUBnnkomiHsD{margin-bottom:50px}.oJabhDcf2PlWJlfNhcvZ{display:flex;flex-direction:row;justify-content:center;align-items:center}.i_f4OTiQMb_FmqvowCDY{margin-top:44px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layoutCards": "ISlOXhkxs4Th6ZaYXjBW",
	"layoutCurrentHospital": "THRSgafRXuhbc9r0u8aO",
	"layoutHeading": "b5CbZWM8BUBnnkomiHsD",
	"buttonShowMore": "oJabhDcf2PlWJlfNhcvZ",
	"hospitalNoFoundData": "i_f4OTiQMb_FmqvowCDY"
};
export default ___CSS_LOADER_EXPORT___;
